export enum ApplianceDetailsSteppedFormField {
  ApplianceCategoryCode = 'applianceCategoryCode',
  ApplianceCode = 'applianceCode',
  ApplianceCodeBuiltIn = 'applianceCodeBuiltIn',
  BrandCode = 'brandCode',
  ModelAndSerialNumber = 'modelAndSerialNumber',
  PartsWarranty = 'partsWarranty',
  Person = 'person',
  PurchaseDate = 'purchaseDate',
  PurchasePrice = 'purchasePrice',
  Retailer = 'retailer',
  Warranty = 'warranty',
}
